var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Link_1;
import { JsonConverter, JsonElementType, JsonObject, JsonProperty, OnDeserialized, } from 'ta-json-x';
import { JsonStringConverter } from '../../converters/string-converter';
import { Properties } from './properties';
/**
 * https://readium.org/webpub-manifest/#the-link-object
 */
let Link = Link_1 = class Link {
    _OnDeserialized() {
        /* istanbul ignore next */
        if (!this.href) {
            console.log('Required [Link.Href] is not set!');
        }
    }
};
__decorate([
    JsonProperty('children'),
    JsonElementType(Link_1),
    __metadata("design:type", Array)
], Link.prototype, "children", void 0);
__decorate([
    JsonProperty('href'),
    __metadata("design:type", String)
], Link.prototype, "href", void 0);
__decorate([
    JsonProperty('type'),
    __metadata("design:type", String)
], Link.prototype, "type", void 0);
__decorate([
    JsonProperty('title'),
    __metadata("design:type", String)
], Link.prototype, "title", void 0);
__decorate([
    JsonProperty('rel'),
    JsonConverter(JsonStringConverter),
    JsonElementType(String),
    __metadata("design:type", Set)
], Link.prototype, "rel", void 0);
__decorate([
    JsonProperty('height'),
    __metadata("design:type", Number)
], Link.prototype, "height", void 0);
__decorate([
    JsonProperty('width'),
    __metadata("design:type", Number)
], Link.prototype, "width", void 0);
__decorate([
    JsonProperty('properties'),
    __metadata("design:type", Properties)
], Link.prototype, "properties", void 0);
__decorate([
    JsonProperty('duration'),
    __metadata("design:type", Number)
], Link.prototype, "duration", void 0);
__decorate([
    JsonProperty('bitrate'),
    __metadata("design:type", Number)
], Link.prototype, "bitrate", void 0);
__decorate([
    JsonProperty('templated'),
    __metadata("design:type", Boolean)
], Link.prototype, "templated", void 0);
__decorate([
    OnDeserialized(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Link.prototype, "_OnDeserialized", null);
Link = Link_1 = __decorate([
    JsonObject()
], Link);
export { Link };
//# sourceMappingURL=link.js.map